import { render, staticRenderFns } from "./ListWrapper.vue?vue&type=template&id=2a5770d7&scoped=true"
import script from "./ListWrapper.vue?vue&type=script&lang=js"
export * from "./ListWrapper.vue?vue&type=script&lang=js"
import style0 from "./ListWrapper.vue?vue&type=style&index=0&id=2a5770d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5770d7",
  null
  
)

export default component.exports